import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { routes } from '../../constants/routes';
// Only import and use "containers" for your route
import Portal from '../../containers/Portal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function OutsideMeetingRoutes() {
  const {
    path
  } = useRouteMatch();
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: `${path}${routes.draft}/:callObjectId`,
      component: Portal
    }), /*#__PURE__*/_jsx(Redirect, {
      from: path,
      to: path
    })]
  });
}